import { apiClient } from '../../client'

export interface RtvOverallData {
  rtv_units: number
  no_of_skus: number
  no_of_stores: number
}

export interface RtvGroupedRow {
  name: string
  rtv_units: number
  no_of_skus: number
  no_of_stores: number
}

export interface RtvByCityData extends RtvGroupedRow {
  lat: number
  lng: number
}

export interface RtvByStoreData {
  region: string
  city_name: string
  chain: string
  store_name: string
  rtv_units: number
  no_of_skus: number
  no_of_stores: number
}

export interface RtvBySkuData {
  category: string
  subcategory: string
  brand_name: string
  sku_name: string
  rtv_units: number
  no_of_skus: number
  no_of_stores: number
}

function appendFilterParams(params: URLSearchParams, filters: any): void {
  if (!filters) return

  const append = (key: string, value: any) => {
    if (Array.isArray(value) && value.length) {
      params.append(key, value.join(','))
    } else if (typeof value === 'string' && value.length) {
      params.append(key, value)
    } else if (value != null && value !== '') {
      params.append(key, value.toString())
    }
  }

  append('client_ids', filters.client_ids)
  append('bu_ids', filters.bu_ids)
  append('department_ids', filters.department_ids)
  append('category_ids', filters.category_ids)
  append('subcategory_ids', filters.subcategory_ids)
  append('brand_ids', filters.brand_ids)
  append('sku_ids', filters.sku_ids)
  append('region_ids', filters.region_ids)
  append('city_ids', filters.city_ids)
  append('chain_ids', filters.chain_ids)
  append('store_ids', filters.store_ids)
  append('start_date', filters.start_date)
  append('end_date', filters.end_date)
}

function buildUrl(path: string, filters?: any): string {
  const params = new URLSearchParams()
  appendFilterParams(params, filters)
  const queryString = params.toString()
  return `/business-kpi-dashboards/rtv/${path}${queryString ? '?' + queryString : ''}`
}

class RtvRepository {
  getOverall(filters?: any) {
    return apiClient.get<RtvOverallData>(buildUrl('overall', filters))
  }

  getByReason(filters?: any) {
    return apiClient.get<RtvGroupedRow[]>(buildUrl('by-reason', filters))
  }

  getByRegion(filters?: any) {
    return apiClient.get<RtvGroupedRow[]>(buildUrl('by-region', filters))
  }

  getByCity(filters?: any) {
    return apiClient.get<RtvByCityData[]>(buildUrl('by-city', filters))
  }

  getByChain(filters?: any) {
    return apiClient.get<RtvGroupedRow[]>(buildUrl('by-chain', filters))
  }

  getByCategory(filters?: any) {
    return apiClient.get<RtvGroupedRow[]>(buildUrl('by-category', filters))
  }

  getBySubcategory(filters?: any) {
    return apiClient.get<RtvGroupedRow[]>(buildUrl('by-subcategory', filters))
  }

  getByBrand(filters?: any) {
    return apiClient.get<RtvGroupedRow[]>(buildUrl('by-brand', filters))
  }

  getByStore(filters?: any) {
    return apiClient.get<RtvByStoreData[]>(buildUrl('by-store', filters))
  }

  getBySku(filters?: any) {
    return apiClient.get<RtvBySkuData[]>(buildUrl('by-sku', filters))
  }
}

export const rtvRepository = new RtvRepository()
